import React from "react";
import { ChevronDown, ChevronUp, UserRound, X } from "lucide-react";
import { displaySpeaker } from "./transcriptDocument";

export interface SpeakerLineNavigatorProps {
  label: string;
  /** Which of the speaker's lines is current, counting from 0. */
  at: number;
  total: number;
  onStep: (by: 1 | -1) => void;
  onClose: () => void;
}

const iconButton =
  "flex h-7 w-7 flex-shrink-0 cursor-pointer items-center justify-center rounded-md text-[#6E7480] hover:bg-white hover:text-[#10141B]";

/**
 * A find bar over one speaker's lines (#12489): who, which line of how many,
 * and the arrows between them.
 */
const SpeakerLineNavigator: React.FC<SpeakerLineNavigatorProps> = ({
  label,
  at,
  total,
  onStep,
  onClose,
}) => (
  <div
    role="search"
    aria-label={`Lines by ${label}`}
    className="flex flex-shrink-0 items-center gap-2 border-b border-gray-200 bg-[#F7F8FF] py-1.5 pl-4 pr-3 md:pl-6"
  >
    <span className="flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-md bg-white text-[#2A3DCB]">
      <UserRound className="h-3.5 w-3.5" />
    </span>
    <span className="min-w-0 flex-1 truncate text-sm text-[#10141B]">
      {displaySpeaker(label)}
    </span>
    <span
      role="status"
      className="flex-shrink-0 font-mono text-xs tabular-nums text-[#6E7480]"
    >
      {at + 1}/{total}
    </span>
    <button
      type="button"
      aria-label="Previous line"
      onClick={() => onStep(-1)}
      className={iconButton}
    >
      <ChevronUp className="h-4 w-4" />
    </button>
    <button
      type="button"
      aria-label="Next line"
      onClick={() => onStep(1)}
      className={iconButton}
    >
      <ChevronDown className="h-4 w-4" />
    </button>
    <button
      type="button"
      aria-label={`Close lines by ${label}`}
      onClick={onClose}
      className={iconButton}
    >
      <X className="h-4 w-4" />
    </button>
  </div>
);

export default SpeakerLineNavigator;
